const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        messages: {
          inAttendance: {
            title: "En servicio"
          },
          waiting: {
            title: "Esperando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexiones",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        form: {
          name: "Nombre",
          default: "Por Defecto",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado satisfactoriamente.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        tagFilterLabel: "Etiqueta",
        tagFilterAll: "Todas",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          importMessage:
            "¿Quieres importar todos los contactos desde tu teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          document: "Código",
          tags: "Etiquetas",
          actions: "Acciones",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          documents: "Códigos (RUC/DNI/CE)",
          document: "Código",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          addDocument: "Agregar código",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
      },
      quickAnswersModal: {
        title: {
          add: "Agregar respuesta rápida",
          edit: "Editar respuesta rápida",
        },
        form: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Respuesta rápida guardada correctamente.",
      },
      autoReplyRuleModal: {
        title: {
          add: "Agregar automatización",
          edit: "Editar automatización",
        },
        form: {
          name: "Nombre de la regla",
          whatsapp: "Conexión",
          matchType: "Condición de activación",
          matchTypeKeywords: "Palabras clave",
          matchTypeAny: "Cualquier mensaje",
          keywords: "Palabras clave",
          keywordsHelper:
            "Separadas por coma. Todas deben aparecer en el mensaje para activar la regla.",
          quickAnswer: "Respuesta rápida a enviar",
          media: "Archivo adjunto",
          mediaHelper:
            "Opcional. Imagen, PDF u otro archivo que se envía junto con la respuesta.",
          mediaUpload: "Subir archivo",
          mediaUploading: "Subiendo...",
          mediaOrder: "Orden de envío",
          mediaOrderMediaFirst: "Adjunto primero",
          mediaOrderTextFirst: "Texto primero",
          parentRule: "Regla padre",
          parentRuleNone: "Ninguna (regla raíz)",
          parentRuleHelper:
            "Si eliges una regla padre, esta solo se activa cuando la última respuesta automática enviada al cliente fue esa regla — sirve para armar una conversación de varios pasos.",
          priority: "Prioridad",
          priorityHelper:
            "Si varias reglas activas coinciden, gana la de número más bajo.",
          tagFilter: "Audiencia por etiqueta",
          tagFilterAll: "Todos los clientes",
          tagFilterWithTag: "Solo clientes con etiqueta",
          tagFilterWithoutTag: "Solo clientes sin etiqueta",
          active: "Activa",
          windows: {
            title: "Restricción de horario",
            helper:
              "Si no agregas ninguna ventana, la regla estará siempre activa.",
            add: "+ Agregar ventana de horario",
            type: "Tipo de ventana",
            typeWeekly: "Semanal",
            typeDate: "Fecha específica",
            startTime: "Hora de inicio",
            endTime: "Hora de fin",
            endDayOffset: "Termina N día(s) después",
            endDayOffsetHelper:
              "0 = mismo día, 1 = día siguiente, 2 = dos días después (ej. sábado a lunes).",
            date: "Fecha",
            allDay: "Todo el día",
            days: {
              mon: "Lun",
              tue: "Mar",
              wed: "Mié",
              thu: "Jue",
              fri: "Vie",
              sat: "Sáb",
              sun: "Dom",
            },
          },
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Automatización guardada correctamente.",
      },
      autoReplyRules: {
        title: "Automatizaciones",
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          keywords: "Palabras clave",
          matchTypeAny: "Cualquier mensaje",
          quickAnswer: "Respuesta",
          dependsOn: "Depende de",
          active: "Activa",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar automatización",
        },
        toasts: {
          deleted: "Automatización eliminada correctamente",
        },
        confirmationModal: {
          deleteTitle: "¿Está seguro de que desea eliminar la automatización",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      autoReplyFlowModal: {
        title: {
          add: "Agregar automatización avanzada",
          edit: "Editar automatización avanzada",
        },
        helper:
          "Para respuestas de varios pasos (texto, imagen, audio, video...) que se mandan de una sola vez al dispararse, sin esperar que el cliente responda entre medio.",
        form: {
          name: "Nombre de la regla",
          whatsapp: "Conexión",
          matchType: "Condición de activación",
          matchTypeKeywords: "Palabras clave",
          matchTypeAny: "Cualquier mensaje",
          keywords: "Palabras clave",
          keywordsHelper:
            "Separadas por coma. Todas deben aparecer en el mensaje para activar la regla.",
          parentRule: "Regla padre",
          parentRuleNone: "Ninguna (regla raíz)",
          parentRuleHelper:
            "Si eliges una regla padre, esta solo se activa cuando la última respuesta automática enviada al cliente fue esa regla (simple o avanzada) — sirve para encadenar pasos de una conversación.",
          priority: "Prioridad",
          priorityHelper:
            "Si varias reglas activas coinciden, gana la de número más bajo.",
          tagFilter: "Audiencia por etiqueta",
          tagFilterAll: "Todos los clientes",
          tagFilterWithTag: "Solo clientes con etiqueta",
          tagFilterWithoutTag: "Solo clientes sin etiqueta",
          active: "Activa",
          windows: {
            title: "Restricción de horario",
            helper:
              "Si no agregas ninguna ventana, la regla estará siempre activa.",
            add: "+ Agregar ventana de horario",
            type: "Tipo de ventana",
            typeWeekly: "Semanal",
            typeDate: "Fecha específica",
            startTime: "Hora de inicio",
            endTime: "Hora de fin",
            endDayOffset: "Termina N día(s) después",
            endDayOffsetHelper:
              "0 = mismo día, 1 = día siguiente, 2 = dos días después (ej. sábado a lunes).",
            date: "Fecha",
            allDay: "Todo el día",
            days: {
              mon: "Lun",
              tue: "Mar",
              wed: "Mié",
              thu: "Jue",
              fri: "Vie",
              sat: "Sáb",
              sun: "Dom",
            },
          },
          steps: {
            title: "Secuencia de pasos",
            helper:
              "Se mandan en este orden, uno por uno, con una pequeña pausa entre cada uno.",
            empty: "Todavía no agregaste ningún paso.",
            add: "+ Agregar paso",
            type: "Tipo de paso",
            typeText: "Texto",
            typeImage: "Imagen",
            typeVideo: "Video",
            typeAudio: "Audio (nota de voz)",
            typeDocument: "Documento",
            textPlaceholder: "Escribe el mensaje de este paso...",
            mediaUpload: "Subir archivo",
            mediaUploading: "Subiendo...",
            mediaChange: "Cambiar archivo",
          },
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Automatización avanzada guardada correctamente.",
      },
      autoReplyFlows: {
        title: "Automatizaciones Avanzadas",
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          keywords: "Palabras clave",
          matchTypeAny: "Cualquier mensaje",
          steps: "Pasos",
          dependsOn: "Depende de",
          active: "Activa",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar automatización avanzada",
        },
        toasts: {
          deleted: "Automatización avanzada eliminada correctamente",
        },
        confirmationModal: {
          deleteTitle:
            "¿Está seguro de que desea eliminar la automatización avanzada",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      followUpRuleModal: {
        helper:
          "Envía un recordatorio automático cuando un prospecto (sin etiqueta) deja de responder después de que tú le escribiste.",
        title: {
          add: "Agregar recordatorio de seguimiento",
          edit: "Editar recordatorio de seguimiento",
        },
        form: {
          name: "Nombre de la regla",
          whatsapp: "Conexión",
          funnelStage: "Etapa del embudo",
          funnelStageAny: "Cualquier etapa",
          reminderSection: "Recordatorio (silencio del cliente tras tu mensaje)",
          hoursThreshold: "Horas de silencio antes de recordar",
          hoursThresholdHelper:
            "Se dispara cuando pasan estas horas desde tu último mensaje sin que el cliente responda.",
          quickAnswer: "Respuesta rápida a enviar",
          resolveSection: "Resolver automático (silencio del cliente)",
          resolveHelper:
            "Opcional. Esta acción se realiza cuando se cumple el tiempo configurado desde la última vez que el cliente escribió o interactuó, sin importar cuántas veces hayas respondido tú desde entonces. Déjalo vacío para desactivar esta parte.",
          resolveAfterClientHours: "Horas de silencio antes de resolver",
          resolveAfterClientHoursPlaceholder: "Ej. 48 (vacío = desactivado)",
          active: "Activa",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Recordatorio guardado correctamente.",
      },
      followUpRules: {
        title: "Seguimiento",
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          funnelStage: "Etapa",
          hoursThreshold: "Recordatorio",
          resolveAfterClientHours: "Resolver auto.",
          quickAnswer: "Respuesta",
          active: "Activa",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar recordatorio",
        },
        toasts: {
          deleted: "Recordatorio eliminado correctamente",
        },
        confirmationModal: {
          deleteTitle: "¿Está seguro de que desea eliminar el recordatorio",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Ahorrar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Linhas",
      },
      tickets: {
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir a la cola",
        fieldConnectionLabel: "Transferir to conexión",
        fieldQueuePlaceholder: "Seleccione una cola",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Cola",
        assignedHeader: "Trabajando en",
        noTicketsTitle: "¡Nada acá!",
        connectionTitle: "Conexión que se está utilizando actualmente.",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        buttons: {
          accept: "Acceptar",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Añadir",
        connection: "Conexión",
        willSendFrom: "Va a escribir desde:",
        buttons: {
          ok: "Contactar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          tickets: "Tickets",
          contacts: "Contactos",
          quickAnswers: "Respuestas rápidas",
          queues: "Linhas",
          automations: "Automatizaciones",
          autoReplyRules: "Automatizaciones",
          autoReplyRulesShort: "Simples",
          autoReplyFlows: "Automatizaciones Avanzadas",
          autoReplyFlowsShort: "Avanzadas",
          followUpRules: "Seguimiento",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      queues: {
        title: "Linhas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          actions: "Comportamiento",
        },
        buttons: {
          add: "Agregar cola",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa cola seguirán existiendo, pero ya no tendrán ninguna cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Linhas",
      },
      quickAnswers: {
        title: "Respuestas rápidas",
        table: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar respuesta rápida",
        },
        toasts: {
          deleted: "Respuesta rápida eliminada correctamente",
        },
        searchPlaceholder: "Buscar ...",
        confirmationModal: {
          deleteTitle:
            "¿Está seguro de que desea eliminar esta respuesta rápida?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la cola.",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Escriba un mensaje o presione '' / '' para usar las respuestas rápidas registradas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Otra información",
        inkamoney: {
          title: "InkaMoney",
          loading: "Buscando en InkaMoney...",
          notFound: "Sin historial en InkaMoney",
          error: "No se pudo consultar InkaMoney",
          noDocument: "Sin código asociado a este contacto",
          empty: "Sin información",
          productos: "Productos",
          ordenes: "Órdenes",
          activo: "Activo",
          inactivo: "De baja",
        },
        tabs: {
          info: "Info",
        },
      },
      ticketOptionsMenu: {
        delete: "Borrar",
        transfer: "Transferir",
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_TICKET_OPEN_WITHOUT_USER:
          "No se pudo aceptar el ticket (sesión inestable justo en ese momento). Inténtalo de nuevo.",
        ERR_AGENT_IA_ROUTE_MISSING_FIELDS:
          "Elige una etiqueta y un agente para crear el enrutamiento.",
        ERR_AGENT_IA_ROUTE_NOT_FOUND: "Ese enrutamiento ya no existe.",
        ERR_AGENT_IA_DRAFT_NOT_FOUND: "Esa sugerencia ya no existe.",
        ERR_AGENT_IA_DRAFT_ALREADY_RESOLVED:
          "Esta sugerencia ya fue enviada o descartada.",
        ERR_QUICK_ANSWER_CATEGORY_DUPLICATED:
          "Ya existe una categoría con ese nombre.",
        ERR_QUICK_ANSWER_CATEGORY_NOT_FOUND: "Esa categoría ya no existe.",
        ERR_QUICK_ANSWER_NEEDS_MESSAGE_OR_MEDIA:
          "Agrega un texto o un archivo adjunto (audio, video, imagen o documento).",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una cola.",
      },
    },
  },
};

export { messages };
